import React, { useContext, useMemo } from 'react';
import T, { t } from '../../../../common/components/T';
import classNames from 'classnames';
import css from './Activity.module.scss';
import UserContext from '../../../../common/utils/getContext';
import moment from 'moment';
import { LangContext } from '../../../../common/decorators/Language';

export default function Activity({ val }) {
    const { time } = useContext(UserContext);
    const { translation } = useContext(LangContext);
    const now = moment(time());

    const sourceDate = val.activity ? val.activity_from : val.activity_end;
    const dateMoment = useMemo(() => {
        if (!sourceDate) return null;

        // якщо бек інколи дає 'YYYY-MM-DD HH:mm:ss'
        const m = moment(sourceDate, ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true);
        return m.isValid() ? m : null;
    }, [sourceDate]);

    const dateText = dateMoment ? dateMoment.format('DD.MM.YYYY') : '';
    const pluralDaysRu = (n) => {
        const abs = Math.abs(n) % 100;
        const last = abs % 10;

        if (abs > 10 && abs < 20) return t('activeDays1', 'дней', 'all', translation);
        if (last > 1 && last < 5) return t('activeDays2', 'дня', 'all', translation);
        if (last === 1) return t('activeDays3', 'день', 'all', translation);
        return t('activeDays1', 'дней', 'all', translation);
    };
    let fullDaysLeft = null;
    if (dateMoment) {
        fullDaysLeft = val.activity
            ? now.diff(dateMoment, 'days') // скільки днів активний
            : dateMoment.diff(now, 'days'); // скільки днів до завершення
    }

    return (
        <div className={css.wrapper}>
            <p className={classNames(css.textDate, { [css.activeText]: val.activity })}>
                {val.activity ? <T textName='active' defaultStr='Активен' /> : <T textName='unactive' defaultStr='Не активен' />}
                {dateMoment
                    ? ` ${t('activeDaysFrom', 'с', 'all', translation)} ${dateText} (${fullDaysLeft} ${pluralDaysRu(
                          fullDaysLeft
                      )})`
                    : ''}
            </p>
        </div>
    );
}
